import React from 'react';
import styles from '../styles';
import { IconButton, IconTextButton } from '@xpertdox_js/xdcomponents';
import {btn_c_clearToShade, btn_c_xdHighlight} from '@xpertdox_js/xdstyle';
import PatientInformation from '../Panels/PatientInformation';
import PatientStudyDetails from '../Panels/PatientStudyDetails';
import MessagesPanel from '../Panels/Messages';
import LogsComponent from "../../Common/LogsComponent";
import {UserContext} from "../../../Context/UserContext";
import {InstanceContext} from "../../../InstanceContext";

export default ({handleSave, diffRef, setDiff, filters, id, childStore, setChildStore, overviewData, allNctsToPass, patientTriageNcts, match, history}) => {
  const { user } = React.useContext(UserContext)
  const handleNextNct = () => {
    let currentNctIndex = allNctsToPass.indexOf(id);
    if (currentNctIndex < allNctsToPass.length - 1) {
      let nextNct = allNctsToPass[currentNctIndex + 1]
      history.push({
        pathname: `/${match.params.instance}/user/overview/${nextNct}`,
        state: history.location.state,
      });
    }
  }

  let currentNctIndex = allNctsToPass.indexOf(id);

  const handlePreviousNct = () => {
    if (currentNctIndex > 0) {
      let previousNct = allNctsToPass[currentNctIndex - 1];
      history.push({
        pathname: `/${match.params.instance}/user/overview/${previousNct}`,
        state: history.location.state,
      });
    }
  }

  // -- window display widgets
  const tabWidget = (key) =>
  <div style={styles.tabWidgetContainer}>
    {allNctsToPass.length > 0 && <React.Fragment>
      { (currentNctIndex && currentNctIndex > 0) ? <IconButton
        onClick={handlePreviousNct}
        styles={styles.btns}
        icon='arrowLeft'
        preBuiltStyles={btn_c_clearToShade}
        size='md'
      /> : null}
      <IconButton
        onClick={handleNextNct}
        styles={styles.btns}
        icon='arrowRight'
        preBuiltStyles={btn_c_clearToShade}
        size='md'
      />
    </React.Fragment>}
    {Object.keys(diffRef.current.diff).length > 0 &&
      <IconTextButton
        onClick={handleSave}
        styles={{...styles.btns, ...styles.saveBtn}}
        preBuiltStyles={btn_c_xdHighlight}
        key={key.id}
        icon='save'
        text='Save'
        size='md'
      />
    }
  </div>;

  // -- dry vars
  const mainContentProps = {data: overviewData, diff: diffRef.current.diff, setDiff}

  return ({
    patientInformation: {
      title: 'Patient Information',
      window: 1,
      content: (width) => <PatientInformation
        {...mainContentProps}
        diff={diffRef.current.diff}
        width={width}
        filters={filters}
        user={user}
        patientId={id}
      />,
      widgets: {tab: tabWidget},
      width: 70,
      defaultWith: 'studyDetails',
    },
    studyDetails: {
      window: 2,
      title: 'Study Details',
      content: (width) => <React.Fragment>
        <PatientStudyDetails data={overviewData} width={width} />
        <LogsComponent data={overviewData.logs} nctId={id} user={user}/>
      </React.Fragment>,
      width: 30,
      defaultWith: 'patientInformation',
    },
    // -> form/dynamic panels
    // messagesPanel :{
    //   title: 'Messages',
    //   window: 1,
    //   content: (width) => <MessagesPanel {...mainContentProps}
    //     width={width}
    //     user={user}
    //     patientId={id}
    //     nct={overviewData.nct_id}
    //   />,
    //   widgets: {tab: tabWidget},
    //   width: 70,
    //   defaultWith: 'studyDetails',
    // },
  })
}
